import { SET_DASHBOARD_CHART_DATA, SET_DASHBOARD_SUMMARY, SET_DASHBOARD_TOP_JOBS, SET_JOB_LIST, SET_NOTIFICATIONS } from "../Types/types";

const initialState = {
  chartData: {
    labels: [],
    series: [],
  },
  summaryData: null,
  topJobsData: {
    telephonic: [],
    video: [],
    ai: []
  },
  jobList:[],
  notifications: [],
};

export default function dashboardReducer(state = initialState, action) {
  switch (action.type) {
    case SET_DASHBOARD_CHART_DATA:
        return { ...state, chartData: action.payload};
    case SET_DASHBOARD_SUMMARY:
      return { ...state, summaryData: action.payload };
    case SET_DASHBOARD_TOP_JOBS:
        const category = action.payload.__category;  
        return { ...state, topJobsData: {...state.topJobsData, [category]: action.payload.data }};
    case SET_JOB_LIST:
      return { ...state, jobList: action.payload}
    case SET_NOTIFICATIONS : 
      return { ...state, notifications: action.payload.data, pagination: action.payload.pagination || {}, };
    default:
      return state;
  }
}
